import { Link } from "react-router-dom";

const footerLinks = [
  { label: "Início", to: "/" },
  { label: "Sobre", to: "/about" },
  { label: "Serviços", to: "/services" },
  { label: "Contato", to: "/contact" },
];

export default function FooterBottom({ copyrightYear }) {
  return (
    <div className="site-footer__bottom">
      <div className="container site-footer__bottom-content">
        <div className="site-footer__bottom-left">
          <p>© {copyrightYear} Dionara Krause. Todos os direitos reservados.</p>
        </div>

        <div className="site-footer__bottom-center">
          <nav className="site-footer__legal-links" aria-label="Links do rodapé">
            {footerLinks.map((link, index) => (
              <span className="site-footer__legal-link-item" key={link.to}>
                {index > 0 && <span aria-hidden="true">|</span>}
                <Link to={link.to}>{link.label}</Link>
              </span>
            ))}
          </nav>
        </div>

        <div className="site-footer__bottom-right">
          <p>
            Desenvolvido por{" "}
            <a
              className="site-footer__dev-link"
              href="https://hrtechsolutions.com.br"
              target="_blank"
              rel="noopener noreferrer"
            >
              HRTech Solutions
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}